import script from "./WhoWeHelpedCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WhoWeHelpedCard.vue?vue&type=script&setup=true&lang=js"

import "./WhoWeHelpedCard.vue?vue&type=style&index=0&id=b6b5d664&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6b5d664"]])

export default __exports__